import { connectHook } from '../../connect-hook.js';
import { SingleLineTextWidget } from './single-line-text.js';
import { type SingleLineTextWidgetOwnProps, useSingleLineText } from './single-line-text-hook.js';

export type SingleLineTextWidgetProps = SingleLineTextWidgetOwnProps;

export default connectHook(SingleLineTextWidget, useSingleLineText);
